export default "__VITE_ASSET__C6E6MD8x__"